import { PlanFeature } from '../types/permissions';

/**
 * Maps sidebar menu item IDs to required plan features
 * If a menu item is not listed here, it's available to everyone
 */
export const SIDEBAR_PERMISSIONS: Record<string, PlanFeature> = {
  // Main menu items
  'affiliate-programs': PlanFeature.AFFILIATE_PROGRAMS,
  'campaigns': PlanFeature.CAMPAIGNS,
  'post-checkout': PlanFeature.POST_CHECKOUT_REFERRALS,
  'affiliates': PlanFeature.AFFILIATES,
  'products': PlanFeature.PRODUCTS,
  'payouts': PlanFeature.PAYOUTS,
  'tiktok-shop': PlanFeature.TIKTOK_SHOP,
  
  // Sub-items
  'products-analytics': PlanFeature.PRODUCTS,
  'programs-analytics': PlanFeature.AFFILIATE_PROGRAMS,
  'share-resources': PlanFeature.SHARE_RESOURCES,
  'compliance': PlanFeature.TAX_FORMS_1099,
  
  // Email automations (if you have it in sidebar)
  'email-automations': PlanFeature.EMAIL_AUTOMATIONS,
};

/**
 * Get the required feature for a menu item
 */
export function getMenuItemRequiredFeature(menuItemId: string): PlanFeature | null {
  return SIDEBAR_PERMISSIONS[menuItemId] || null;
}

/**
 * Check if a menu item should be shown based on permissions
 */
export function shouldShowMenuItem(
  menuItemId: string,
  hasFeature: (feature: PlanFeature) => boolean
): boolean {
  const requiredFeature = getMenuItemRequiredFeature(menuItemId);
  
  // If no feature is required, show the item
  if (!requiredFeature) {
    return true;
  }
  
  // Check if user has the required feature
  return hasFeature(requiredFeature);
}
